import { Routes } from '@angular/router';
import { GebaeudeListComponent } from './gebaeude-list/gebaeude-list.component';
import { GebaeudeSucheComponent } from './gebaeude-suche/gebaeude-suche.component';
import { GebaeudeDetailComponent } from './gebaeude-detail/gebaeude-detail.component';
import { GebaeudeFormService } from './gebaeude-form.service';
import { PermissionResponse } from '../../core/base-api';
import { canActivateAuthorization } from '../../security/authorization.guard';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

export const GebaeudeRoutes: Routes = [
  {
    path: 'gebaeude',
    loadChildren: () => routes,
    providers: [GebaeudeFormService]
  }
];

const routes: Routes = [
  {
    path: '',
    component: GebaeudeSucheComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.GEBAEUDE_REGISTER],
      breadcrumb: 'gebaeude.BreadcrumbSuche',
      breadcrumbStatus: 'firstLevel'
    }
  },
  {
    path: 'list/:searchMode',
    component: GebaeudeListComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.GEBAEUDE_REGISTER],
      breadcrumb: 'shared.breadcrumb.list',
      breadcrumbStatus: 'secondLevel'
    }
  },
  {
    path: 'detail',
    component: GebaeudeDetailComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.GEBAEUDE_REGISTER]
    }
  }
];
